import React from 'react';
import { css } from '@emotion/css';
import useTheme from 'evcharging/hooks/useTheme';
import drops from 'evcharging/assets/occp/drops.png';
import book from 'evcharging/assets/occp/book.png';
import mobileBook from 'evcharging/assets/occp/book-mobile.png';
import Title from 'evcharging/components/Title';
import Paragraph from 'evcharging/components/Paragraph';
import Spacer from 'evcharging/components/Spacer';
import Desktop from 'evcharging/components/Desktop';
import Mobile from 'evcharging/components/Mobile';
import { Theme } from 'evcharging/app/themes';
import useI18n from 'evcharging/hooks/useI18n';
import Image from 'next/image';

const Interoperability = () => {
  const theme = useTheme();
  const styles = createStyles(theme);
  const { t } = useI18n();

  return (
    <div className={styles.root}>
      <Desktop>
        <div className={styles.image}>
          <Image src={book} width={745} height={428} alt={t('ocpp.why.title')} />
        </div>
      </Desktop>
      <Mobile>
        <div className={styles.image}>
          <Image src={mobileBook} width={264} height={152} alt={t('ocpp.why.title')} />
        </div>
      </Mobile>
      <Spacer value={98} mobile={50} />
      <div className={styles.inner}>
        <Desktop>
          <Title variant={'h2'} center>
            {t('ocpp.why.title')}
          </Title>
        </Desktop>
        <Mobile>
          <Title>{t('ocpp.why.title')}</Title>
        </Mobile>
        <Spacer value={16} />
        <Paragraph color={'middle'}>{t('ocpp.why.body')}</Paragraph>
      </div>
    </div>
  );
};

const createStyles = (theme: Theme) => ({
  root: css`
    background: #f6f8f9 url('${drops}') no-repeat;
    background-size: cover;
    height: 694px;
    text-align: center;

    ${theme.breakpoints.mobile.down} {
      background: #f6f8f9;
      height: 552px;

      img {
        margin-top: -44px;
      }
    }
  `,
  image: css`
    display: inline-block;
    max-width: 720px;
    margin: -70px auto 0;
    ${theme.breakpoints.mobile.down} {
      margin-top: -44px;
    }
  `,
  inner: css`
    max-width: 1014px;
    margin: 0 auto;
    text-align: center;

    ${theme.breakpoints.mobile.down} {
      text-align: left;
      padding: 0 15px;
    }
  `,
});

export default Interoperability;
